<template>
    <el-form size="mini" :inline="true" :model="form">
        <el-form-item label="姓名">
            <el-input v-model="form.user" placeholder="患者姓名"></el-input>
        </el-form-item>
        <el-form-item label="申请医院">
            <el-select v-model="form.region" placeholder="申请医院">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="被申请医院">
            <el-select v-model="form.region" placeholder="被申请医院">
                <el-option label="区域一" value="shanghai"></el-option>
                <el-option label="区域二" value="beijing"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
            <el-button type="primary">查询</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
  export default {
    name: "dignose-search-form",
    props: {
      value: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        form: {}
      }
    },
  }
</script>

<style scoped>

</style>
